import { render, staticRenderFns } from "./CallcentreQueueManage.vue?vue&type=template&id=ff1fcb2c&"
import script from "./CallcentreQueueManage.vue?vue&type=script&lang=js&"
export * from "./CallcentreQueueManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports